const initialState = {
   open: false,
   mensaje: '',
   accionAceptar: null,
   aceptarLabel: 'Eliminar'
};

const sliceConfig = {
   name: 'msg',
   initialState: initialState,
   reducers: {
      close(state) {
         state.open = initialState.open;
         state.mensaje = initialState.mensaje;
         state.accionAceptar = initialState.accionAceptar;
         state.aceptarLabel = initialState.aceptarLabel;
      },
      open(state, action) {
         state.open = true;
         state.mensaje = action.payload.mensaje;
         state.accionAceptar = action.payload.accionAceptar;
         state.aceptarLabel = action.payload.aceptarLabel;
      }
   }
};

export function open(mensaje, accionAceptar, aceptarLabel) {
   return async function (dispatch) {
      dispatch({
         type: 'msg/open',
         payload: {
            mensaje,
            accionAceptar,
            aceptarLabel
         }
      });
   };
}

export default sliceConfig;
